import { type RequestServiceOptions, utils } from '@atlaskit/util-service-support';

import type { RESTRequest, RESTResponse } from './types';

export async function fetchRestResponse<Variables, Data>({ url, body }: RESTRequest<Variables>): Promise<RESTResponse<Data>> {
	const options: RequestServiceOptions = {
		requestInit: {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		},
	};
	return utils.requestService<RESTResponse<Data>>({ url }, options);
}
